import OdooCustomerAddressView from "components/shared/OdooCustomerAddressView";

const CustomerAddressView = ({ odooCustomer }) => {
  const res = odooCustomer.child_ids;
  console.log("res", res);

  const addressByTypes = res.reduce((acc, item) => {
    if (!acc[item.type]) {
      acc[item.type] = [];
    }
    acc[item.type].push(item);
    return acc;
  }, {});

  return (
    <div className="mt-4 space-y-6">
      {res.length === 0 && (
        <div className="opacity-70">
          No addresses found in Odoo for this customer.
        </div>
      )}

      {Object.keys(addressByTypes).map((type) => (
        <div key={type}>
          <h5 className="capitalize">{type}</h5>
          <div className="mt-2 -mx-1 grid grid-cols-3 gap-6 border-t dark:border-gray-700 pt-4">
            {addressByTypes[type].map((i) => (
              <div
                key={i.id}
                className="bg-gray-100 dark:bg-gray-900 dark:bg-opacity-80 p-4 rounded-xl"
              >
                <OdooCustomerAddressView address={i} />
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default CustomerAddressView;
